import { Factory } from 'miragejs';
import { faker } from '@faker-js/faker';

export default Factory.extend({
  name: () => faker.lorem.word(),
  roomsNotificationEmails: () => [faker.internet.email()],
  roomsShouldEmailGlobalAdmins: () => false,
  roomsShouldEmailLocationAdmins: () => false,
  onsiteRoomRecaptureEnabledOverride: () => null,
  roomResizerEnabledOverride: () => null,
  onsiteRoomRecaptureEnabled: () => true,
  roomResizerEnabled: () => true,
  roomsPreCheckInWindow: () => 1,
  roomsPreCheckInWindowIsOverride: () => true,
  roomsCheckInWindow: () => 1,
  roomsCheckInWindowIsOverride: () => true,
  roomCheckInEnabled: () => false,
});
